// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__zRo__","skeleton-loading":"Skeleton_skeleton-loading__3r8MR"};